import { isElementInViewport } from '@theme/utilities';

/**
 * Barre "Ajouter au panier" collante.
 *
 * Nekkat : la barre n'apparait plus des l'arrivee sur la page.
 * Trois conditions doivent etre reunies pour l'afficher :
 *   1. la page a ete defilee d'au moins REVEAL_RATIO x la hauteur de l'ecran,
 *   2. le bouton principal du formulaire produit n'est plus visible,
 *   3. le footer n'est pas visible.
 */

/** Part de la hauteur d'ecran a defiler avant que la barre puisse apparaitre. */
const REVEAL_RATIO = 0.75;

/** Defilement minimum en pixels (securite sur les tres petits ecrans). */
const REVEAL_MIN = 300;

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = null;
    this.footer = null;
    this.ticking = false;
    this.handleScroll = this.handleScroll.bind(this);
  }

  connectedCallback() {
    this.form = this.closest('[data-ref="product-form"]');
    this.footer = document.querySelector('[data-ref="footer"]');

    this.#displayStickyAddToCart();

    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleScroll, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleScroll);
  }

  handleScroll() {
    if (this.ticking) return;
    this.ticking = true;

    requestAnimationFrame(() => {
      this.ticking = false;
      this.#displayStickyAddToCart();
    });
  }

  #hasScrolledEnough() {
    const threshold = Math.max(REVEAL_MIN, window.innerHeight * REVEAL_RATIO);
    return window.scrollY > threshold;
  }

  #displayStickyAddToCart() {
    const formVisible = !this.form || isElementInViewport(this.form);
    const footerVisible = this.footer ? isElementInViewport(this.footer) : false;

    if (this.#hasScrolledEnough() && !formVisible && !footerVisible) {
      this.dataset.active = 'true';
      this.classList.add('color-scheme-1');
    } else {
      this.dataset.active = 'false';
      this.classList.remove('color-scheme-1');
    }
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
